export default __webpack_public_path__ + "static/storylava-icon-8fb27d4103eebe476774be46c94c925e.png";